
import {timer as observableTimer,  Observable, Subscription } from 'rxjs';
import { Component, OnInit, HostListener, ViewChild, AfterContentInit, OnDestroy } from '@angular/core';
import DateTime from 'typescript-dotnet-es6/System/Time/DateTime';
import { auditList } from '../../../test-support/auditList';
import { RvService, UserProfileService, dropdownMenuInfo  } from '../../../core';
import { DialogService, DialogRef, DialogCloseResult } from '@progress/kendo-angular-dialog';
import { State } from '@progress/kendo-data-query';
import {
  GridDataResult,
  DataStateChangeEvent
  , SelectionEvent
} from '@progress/kendo-angular-grid';

import { AlertComponent, EnumAlertType } from '../../../common/component/alert/alert.component';
import { modalComponent } from '../../../common/component/modal/modal.component';
import { rv_modalComponent } from '../../../common/component/rv_modal/rv_modal.component';


@Component({
  selector: 'rv-grid',
  templateUrl: './rv-grid.component.html',
  styleUrls: ['./rv-grid.component.scss']
})
export class RvGridComponent implements OnInit, AfterContentInit, OnDestroy {
  @ViewChild(AlertComponent, { static: true }) alertController: AlertComponent;

  public view: GridDataResult;
  public state: State = {
    skip: 0,
    take: 10
  };

  public sorted: string = "";
  public norecords: boolean = true;
  public userProfile;
  public isSuperUser: boolean = false;
  public openChart: boolean = false;
  public ChartData: any[] = [];
  public subTitle;
  public universalAuditID;
  public auditId;
  public component;
  public selectedAudit:string[]=[];
  public AuditNotificationID;
  public AuditScheduleID;
  subscriptions: Subscription[] = [];

  constructor(
    private service: RvService,
    private userProfileService: UserProfileService,
    private dialogService: DialogService,
    private rvdialogService: DialogService) {
    this.refreshdata();
    this.userProfile = userProfileService;
  }

  ngOnInit() {

    this.dialogTitle = "Delete Audit";
    this.dialogTextLine1 = "Are you sure you want to delete this audit?";
    this.dialogTextLine2 = "This action cannot be undone";
    this.primaryButtonText = "Ok";
    this.secondaryButtonText = "Cancel";
    this.rv_dialogTitle = "Edit Audit";
    this.rv_primaryButtonText = "Ok";
    this.rv_secondaryButtonText = "Cancel";
    var user = this.userProfileService.data.RoleList;

    if (user[0] == "Super User") {
      this.isSuperUser = true
    } else { this.isSuperUser = false };

  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  ngAfterContentInit() {
    let timer = observableTimer(1000, 20000);

    this.selectedAudit[0] = sessionStorage.getItem('selectedAvlAudit');

    const s1 = timer.subscribe(t => {
      this.refreshdata();
    }
    , err => {
      console.log(err);
    }
    , () => console.log("complete called for Observable.timer(1000,30000)")
      );
    this.subscriptions.push(s1);
  }


  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.sorted = "";
    this.sorted = (state.sort.find(e => e.dir === 'asc' || e.dir == 'desc') || { 'field': '' }).field;
    if(this.sorted=="")
      this.state.sort=[];
    this.refreshdata();
  }

  ////Display charts
  public onDisplayChart(AuditScheduleID: any, jobId: any) {
    //this.universalAuditID=jobId;
    this.service.GetRVChart(AuditScheduleID).
      subscribe(data => {
        if (data != null) {
          this.ChartData = data;
          this.subTitle = "Rate Availability"
          this.universalAuditID = jobId;
          this.component = "RV";
          this.openChart = true;
        }

      }, (error) => {
        this.universalAuditID = jobId;
        var err = "Audit " + this.universalAuditID + " does not contain completion information needed to render the graph";
        this.alertController.showAlertMessage(5000, err, EnumAlertType.Error);
        this.openChart = false;
      });
  }

  public closeChartModals() {
    this.openChart = false;
  }


  //To capture the chart icon click event
  @HostListener('click', ['$event'])
  onClick(event) {
    if (event.toElement && event.toElement.className == "cvt-icon-reports grid-cmd-icons") {
      var evt = event ? event : window.event;
      if (evt.stopPropagation) evt.stopPropagation();
      if (evt.cancelBubble != null) evt.cancelBubble = true;
    }
    else {
      return true;
    }
  }

  public selectionChange(event: SelectionEvent) {
    this.selectedAudit[0] = event.selectedRows[0].dataItem.AuditScheduleID;
    sessionStorage.setItem('selectedAvlAudit', this.selectedAudit[0].toString());
  }

  public deleteAudit() {
    this.service.DeleteAudit(this.auditId.toString()).subscribe(r => { this.refreshdata() }, err => { console.log(err) });
  }

  public refreshdata() {
    this.service.getGridData(this.state).
      subscribe(data => {
        if(data){
          this.view = data;
          if (data.total == undefined || data.total == 0) {
            this.norecords = false;
          } else {
            this.norecords = true;
          }
        }
        else{
          this.userProfileService.CheckAndHandleSessionTimeout();
        }
      },
      err=> this.userProfileService.ProcessRiaWcfServiceErrorResponse(err)
      );;
  }

  public onDelete(event: any) {
    this.auditId = event;
    this.showModal(event);
  }

  @ViewChild(modalComponent, { static: false }) modalController: modalComponent;
  dialogTitle: string;
  dialogTextLine1: string;
  dialogTextLine2: string;
  primaryButtonText: string;
  secondaryButtonText: string;
  public openModal: boolean = false;
  public kendoDialog: boolean = true;
  public showModal(xyz: any): void {

    this.openModal = true;
    const dialog: DialogRef = this.dialogService.open({
      content: modalComponent
    });
  }

  public closeModals(): void {
    this.kendoDialog = false;
    this.openModal = false;
  }

  public okButtonClick(): void {
    this.deleteAudit();
    this.kendoDialog = false;
    this.openModal = false;
  }

  //edit button modal
  public onOpenEditModal(auditId: any, name: any, audit_date: any, AuditNotificationID: any, AuditScheduleID: any) {
    this.rv_showModal(auditId, name, audit_date, AuditNotificationID, AuditScheduleID);
  }

  @ViewChild(rv_modalComponent, { static: false }) rv_modalController: rv_modalComponent;
  rv_dialogTitle: string;
  rv_primaryButtonText: string;
  rv_secondaryButtonText: string;

  public plusDropDownState: boolean = false;
  public auditCreateMapping: Array<dropdownMenuInfo> = [
    { text: 'Upload File', path: "../upload-and-create" },
    { text: 'Create from Rate Audit', path: "../create" },
  ]

  public rv_openModal: boolean = false;
  public rv_kendoDialog: boolean = false;
  public auditID: any;
  public auditName: any;
  public auditProcessedWhen: any;

  public rv_showModal(auditId: any, name: any, audit_date: Date, AuditNotificationID: any, AuditScheduleID: any): void {
    this.auditID = auditId;
    this.auditName = name;
    let now: () => DateTime = () => DateTime.now;
    let earliest:Date = now().date.toJsDate();
    if(earliest > audit_date){
      audit_date = earliest;
    }
    this.auditProcessedWhen = audit_date;
    this.AuditNotificationID = AuditNotificationID;
    this.AuditScheduleID = AuditScheduleID;

    this.rv_openModal = true;
    const rvdialog: DialogRef = this.rvdialogService.open({
      content: rv_modalComponent
    });
  }

  public rv_closeModals(): void {
    this.rv_kendoDialog = false;
    this.rv_openModal = false;
    this.kendoDialog = false;
  }


  public rv_okButtonClick(): void {
    this.refreshdata();
    this.rv_kendoDialog = false;
    this.rv_openModal = false;
    this.kendoDialog = false;

  }

}
